import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/97 backdrop-blur-md py-3'
          : 'bg-[#F9F8F5]/85 backdrop-blur-sm py-5'
      }`}
      style={{ borderBottom: scrolled ? '1px solid #E8E6E0' : '1px solid transparent' }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/38a0fe6b-1e54-4ff4-ae8d-2258d722dfac/041ad50a-862f-4d87-b6bb-11d7913a719a_smile-logo-transparent-211x85.png?v=de4dea040c26dbb72c9fc9dbc007ad7a"
            alt="Smile By Dr. K – Orthodontics Chatsworth CA"
            className="h-10 w-auto"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: 'Services', href: '#services' },
            { label: 'About', href: '#about' },
            { label: 'Technology', href: '#technology' },
            { label: 'Contact', href: '#contact' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm tracking-wide font-medium text-[#3A5245] hover:text-[#1C3528] transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="tel:8183415150"
            className="text-sm font-medium text-[#3A5245] hover:text-[#1C3528] transition-colors duration-200 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            (818) 341-5150
          </a>
          <a
            href="https://smilebydrkortez.com/request-appointment"
            target="_blank"
            rel="noopener nofollow"
            className="bg-[#1C3528] hover:bg-[#254535] text-white text-sm font-medium px-5 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-colors duration-200"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Book Appointment
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer text-[#1C3528]"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#E8E6E0] px-6 py-5 flex flex-col gap-4">
          {[
            { label: 'Services', href: '#services' },
            { label: 'About', href: '#about' },
            { label: 'Technology', href: '#technology' },
            { label: 'Contact', href: '#contact' },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setMenuOpen(false)}
              className="text-sm font-medium text-[#3A5245] cursor-pointer hover:text-[#1C3528]"
              style={{ fontFamily: 'DM Sans, sans-serif' }}
            >
              {item.label}
            </a>
          ))}
          <a
            href="tel:8183415150"
            className="text-sm font-medium text-[#3A5245]"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            (818) 341-5150
          </a>
          <a
            href="https://smilebydrkortez.com/request-appointment"
            target="_blank"
            rel="noopener nofollow"
            className="bg-[#1C3528] text-white text-sm font-medium px-5 py-2.5 rounded-full text-center whitespace-nowrap cursor-pointer"
            style={{ fontFamily: 'DM Sans, sans-serif' }}
          >
            Book Appointment
          </a>
        </div>
      )}
    </header>
  );
}
